module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-108.f2203c8e.svg";